if (!customElements.get('homducts-recently-viewed')) {
  customElements.define('homducts-recently-viewed', class extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      const normalize = (value) => {
        if (typeof value !== 'string') return null;
        try {
          const url = new URL(value, location.origin);
          if (url.origin !== location.origin || url.username || url.password) return null;
          const match = url.pathname.match(/^(?:\/[a-z]{2}(?:-[a-z]{2})?)?\/products\/([a-z0-9][a-z0-9-]*)\/?$/i);
          if (!match) return null;
          const root = new URL(this.dataset.rootUrl || '/', location.origin).pathname.replace(/\/?$/, '/');
          return `${root}products/${match[1]}`;
        } catch { return null; }
      };
      const current = normalize(this.dataset.productUrl);
      if (!current) return;
      let history = [];
      try {
        const saved = JSON.parse(localStorage.getItem('recently_viewed') || '[]');
        if (Array.isArray(saved)) history = saved.slice(-20).map(item => normalize(typeof item === 'string' ? item : item?.productUrl)).filter(Boolean);
      } catch {}
      history = [...new Set(history)].filter(path => path !== current).slice(-4);
      try { localStorage.setItem('recently_viewed', JSON.stringify([...history, current].map(productUrl => ({ productUrl })))); } catch {}
      if (!history.length) return;
      const load = () => this.loadCards(history.reverse());
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) { this.observer.disconnect(); load(); }
        }, { rootMargin: '200px' });
        this.observer.observe(this);
      } else load();
    }
    disconnectedCallback() { this.observer?.disconnect(); this.controller?.abort(); }
    async loadCards(paths) {
      const ensureAsset = (name, src) => {
        if (customElements.get(name)) return Promise.resolve();
        return new Promise((resolve, reject) => {
          const timer = setTimeout(() => reject(new Error('Component unavailable')), 10000);
          customElements.whenDefined(name).then(() => { clearTimeout(timer); resolve(); });
          if (!Array.from(document.scripts).some(script => script.src === new URL(src, location.href).href)) {
            const script = document.createElement('script');
            script.src = src;
            script.onerror = () => { clearTimeout(timer); reject(new Error('Component unavailable')); };
            document.head.append(script);
          }
        });
      };
      try {
        await Promise.all([ensureAsset('product-form', this.dataset.productFormSrc), ensureAsset('quick-add-modal', this.dataset.quickAddSrc)]);
      } catch { return; }
      if (!this.isConnected) return;
      this.controller = new AbortController();
      const grid = this.querySelector('.js-recentPdpBlock');
      const cards = await Promise.all(paths.map(async (path, index) => {
        try {
          const url = new URL(path, location.origin);
          url.searchParams.set('section_id', 'recently-viewed-card');
          const response = await fetch(url, { signal: this.controller.signal, credentials: 'same-origin' });
          if (!response.ok || new URL(response.url).origin !== location.origin) return null;
          const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
          const card = documentFragment.querySelector('[data-recent-product-card]');
          if (!card) return null;
          card.querySelectorAll('script').forEach(node => node.remove());
          const prefix = `recent-${this.dataset.sectionId}-${index}-`;
          const ids = new Map();
          card.querySelectorAll('[id]').forEach(node => { const old = node.id; node.id = old + '-' + prefix; ids.set(old, node.id); });
          card.querySelectorAll('*').forEach(node => {
            for (const attribute of ['for', 'aria-labelledby', 'aria-describedby', 'aria-controls']) {
              if (node.hasAttribute(attribute)) node.setAttribute(attribute, node.getAttribute(attribute).split(/\s+/).map(value => ids.get(value) || value).join(' '));
            }
            for (const attribute of ['data-modal', 'href']) {
              const value = node.getAttribute(attribute);
              if (value?.startsWith('#') && ids.has(value.slice(1))) node.setAttribute(attribute, '#' + ids.get(value.slice(1)));
            }
          });
          return document.importNode(card, true);
        } catch { return null; }
      }));
      if (!this.isConnected) return;
      grid.replaceChildren(...cards.filter(Boolean));
      this.querySelector('h2').hidden = !grid.children.length;
    }
  });
}
